import { Component, Injector, OnInit, AfterViewInit, Inject, Optional, InjectionToken, ViewEncapsulation, Input, ElementRef, ViewChild, HostListener } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { PlanService, SettingService } from '../../../services/project.service';
import { PlanOutput, SettingOutput, CouponOutput, CommonLookupServiceProxy, UserLoginInfoDto, SubscriptionServiceProxy } from '@shared/service-proxies/service-proxies';
import { DomSanitizer } from '@angular/platform-browser';
import { getAllISOCodes, Currency } from "iso-country-currency";
import { HttpClient } from '@angular/common/http';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { FormsModule } from '@angular/forms';
import { UtilsModule } from '@shared/utils/utils.module';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AbpModule } from 'abp-ng2-module';
import { NgSelectModule } from '@ng-select/ng-select';
import { environment } from 'environments/environment';
import { WebfacingLoginComponent } from 'webfacing/webfacing-login/webfacing-login.component';
import { MomentHelper } from '@shared/helpers/MomentHelper';
import { LoaderService } from '../cablepro/loader.service';
import { WebfacingRegisterComponent } from 'webfacing/webfacing-register/webfacing-register.component';
import { zIndex } from '@node_modules/html2canvas/dist/types/css/property-descriptors/z-index';
import { CompanyAccountService } from '@shared/service-proxies/company-account.service';
import { finalize, takeUntil } from '@node_modules/rxjs/operators';
import { Subject } from '@node_modules/rxjs/internal/Subject';


export const API_STRIPE_KEY_SubscribePlans = new InjectionToken<string>('API_STRIPE_KEY_SubscribePlans');
@Component({
    selector: 'app-subscriptionplans',
    templateUrl: './subscriptionplans.component.html',
    animations: [appModuleAnimation()],
    styleUrls: ['./subscriptionplans.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [FormsModule, NgSelectModule, UtilsModule, AbpModule, CommonModule, RouterModule]
})
export class SubscriptionPlanComponent extends AppComponentBase implements OnInit, AfterViewInit {
    @Input() isFromWebfacing: boolean = false;
    @Input() isFromHomePgae: boolean = false;
    public planOutput: PlanOutput[] = [];
    public annualPlanOutput: PlanOutput[] = [];
    public monthlyPlanOutput: PlanOutput[] = [];
    public comparePlans: any[] = [];
    public groupedComparePlans: any[] = [];
    public stripe: any;
    private stripeKeySubscribePlans: string;
    private calcStandardId: number = 0;
    public settingOutput: SettingOutput = new SettingOutput();
    public subscribePlanResult: string = "";
    public successFlag: boolean = false;
    public errorFlag: boolean = false;
    public plan: PlanOutput = new PlanOutput();

    public ishidebutton: number = 1;

    public Countries: Currency[] = getAllISOCodes();
    public selectedCountry: string = 'AU';
    public selectedCountryObj: Currency = this.Countries.find(m => m.iso == this.selectedCountry);
    public currencyData: any;
    public btnDisabled: boolean = false;
    public user?: UserLoginInfoDto;
    public isMonthly: boolean = false;
    public noOfUsers: number = 1; // Default value for number of users    
    public asStandardCountries: string[] = ['AU', 'NZ', 'FJ', 'PG', 'WS', 'TO', 'SB', 'VU', 'PH', 'MY'];
    public bsStandardCountries: string[] = ['GB', 'MU', 'LC', 'VC', 'SL', 'SG', 'LK', 'TT', 'UG', 'CY'];
    public necStandardCountries: string[] = ['US'];
    @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
    @ViewChild('compareSection') compareSection!: ElementRef;
    @ViewChild('firstColumn') firstColumn!: ElementRef;
    @ViewChild('compareSectionMobile') compareSectionMobile!: ElementRef;
    @ViewChild('firstColumnMobile') firstColumnMobile!: ElementRef;
    showFixedHeader = false;
    showFixedHeaderMobile = false;
    // public drpCableSizing = 0;
    // public cableSizes: any = [
    //     { "id": 0, "text": "Australian Standard AS/NZS 3008.1.1" },
    //     { "id": 1, "text": "New Zealand Standard AS/NZS 3008.1.2" },
    //     { "id": 2, "text": "British Standard BS 7671" },
    //     { "id": 3, "text": "International Standard IEC 60364-5-52" }
    // ]
    // public standardSelectionDisabled: boolean = true;
    constructor(injector: Injector,
        private readonly _planService: PlanService,
        private route: ActivatedRoute,
        private readonly _appSessionService: AppSessionService,
        private readonly loaderService: LoaderService,
        private readonly _subscriptionService: SubscriptionServiceProxy,
        private readonly _commonLookupServiceProxy: CommonLookupServiceProxy,
        private readonly _companyAccountService: CompanyAccountService,
        protected html_sanitizer: DomSanitizer,
        private readonly _router: Router,
        @Optional() @Inject(API_STRIPE_KEY_SubscribePlans) stripeKeySubscribePlans?: string) {
        super(injector);
        this.getCurrentLoginInformations();
        this.checkWidth(window.innerWidth);
        // if (this.user?.companyId > 0 && !this.user.isBillingManager) {
        //     toastr.error(`<span>The page you are trying to access is not available to you.</span>`, ``);
        //     const hostname = location.hostname.toLowerCase();
        //     let isFromWebfacing = hostname === environment.WebFacingHost.toLowerCase();
        //     if (isFromWebfacing) {
        //         location.href = '/';
        //     }
        //     else
        //         this._router.navigate(['/app/main/projects']);
        //     return;
        // }
        this.stripeKeySubscribePlans = stripeKeySubscribePlans ? stripeKeySubscribePlans : "";
        if (this.user?.userSetting !== undefined && this.user?.userSetting !== null) {
            this.settingOutput = this.user?.userSetting;
            // this.drpCableSizing = this.settingOutput.standards_CableSizing;
            if (this.settingOutput.standards_CableSizing == 0)
                this.calcStandardId = 100;
            else if (this.settingOutput.standards_CableSizing == 1)
                this.calcStandardId = 101;
            else if (this.settingOutput.standards_CableSizing == 2)
                this.calcStandardId = 102;
            else if (this.settingOutput.standards_CableSizing == 3)
                this.calcStandardId = 103;
            else if (this.settingOutput.standards_CableSizing == 4)
                this.calcStandardId = 104;
        }
        this.selectedCountry = this.calcStandardId == 100 || this.calcStandardId == 101 ? 'AU' : this.calcStandardId == 102 ? 'GB' : this.calcStandardId == 103 ? 'FR' : this.calcStandardId == 104 ? 'US' : 'AU';
        this.selectedCountryObj = this.Countries.find(m => m.iso == this.selectedCountry);
        this.loadScripts();
        this.ishidebutton = 1;
        this.getCurrentCountry();

        (window as any).pricing = this;
    }

    public calcCount: number = 0;
    public premiumUser!: boolean;
    private isPlanAddedManually: boolean = false;
    public planLevel: string | number = '';
    public hasPlanExpired: boolean;
    fixedStyle: any = {};
    fixedStyleMobile: any = {};

    private scrollTicking = false;
    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (this.scrollTicking) return;

        this.scrollTicking = true;
        requestAnimationFrame(() => {
            this.handleScroll();
            this.scrollTicking = false;
        });
    }

    private handleScroll() {
        const section = this.compareSection?.nativeElement;
        const col = this.firstColumn?.nativeElement;
        if (!section || !col) return;

        const sectionRect = section.getBoundingClientRect();
        const colRect = col.getBoundingClientRect();
        const inView = sectionRect.top <= 0 && sectionRect.bottom > 250;

        if (inView) {
            this.showFixedHeader = true;
            this.fixedStyle = {
                position: 'fixed',
                top: this.isFromWebfacing ? '56px' : this.isFromHomePgae ? '79px' : '70px',
                left: `${colRect.left}px`,
                width: `${colRect.width}px`
            };
        } else {
            this.showFixedHeader = false;
        }

        const sectionMobile = this.compareSectionMobile?.nativeElement;
        const colMobile = this.firstColumnMobile?.nativeElement;
        if (!sectionMobile || !colMobile) return;

        const sectionRectMobile = sectionMobile.getBoundingClientRect();
        const colRectMobile = colMobile.getBoundingClientRect();
        const inViewMobile = sectionRectMobile.top <= 0 && sectionRectMobile.bottom > 260;

        if (inViewMobile) {
            this.showFixedHeaderMobile = true;
            this.fixedStyleMobile = {
                position: 'fixed',
                top: this.isFromHomePgae ? '79px' : this.isFromWebfacing ? '53px' : '0px',
                'z-index': '9999',
                left: `${colRectMobile.left}px`,
                width: `${colRectMobile.width}px`
            };
        } else {
            this.showFixedHeaderMobile = false;
        }
    }

    getCurrentLoginInformations(): void {
        this.user = this._appSessionService.user;
        this.premiumUser = this.user?.premiumUser;
        if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
            && this.user?.periodEndDate == "Inactive") {
            this.premiumUser = false;
        }
        else {
            if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
                && this.user?.periodEndDate != "succeeded") {
                this.premiumUser = false;
            }
        }
        this.planLevel = this.user?.userStripePlanLevel;
        this.isPlanAddedManually = this.user?.isPlanAddedManually;
        this.noOfUsers = this.user?.totalLicenseCount ? this.user?.totalLicenseCount : 1;
        if (this.user?.userStripePlanInterval == 'month') {
            this.isMonthly = true;
        }
        this.hasPlanExpired = this.premiumUser && MomentHelper.IsSubscriptionDateExpired(this.user?.expirationDate);
        // if (!this.trialEnabled)
        //     this.trialEnabled = this._appSessionService.isEligibleForTrial();
    }

    getCurrentCountry() {
        this._ipInfoService.getIpInfo().subscribe((response) => {
            if (response && response.isSuccess) {
                if (response.data && response.data.country) {
                    this.selectedCountry = response.data.country;
                    // Assign only on a hit. An unmatched code would otherwise overwrite the 'AU'
                    // default seeded above with undefined, and sortCountries() dereferences
                    // selectedCountryObj.countryName unguarded - which would throw before
                    // calcStandardId is resolved below and leave it at 0 (the AUD price row).
                    const matchedCountry = this.Countries.find(m => m.iso == this.selectedCountry);
                    if (matchedCountry) {
                        this.selectedCountryObj = matchedCountry;
                    }
                }
            }
            this.sortCountries();
            if (((this.isFromWebfacing && (!this.user || this.user?.isWebFacingUser || !this.user.userSetting)) || this.isFromHomePgae) && this.selectedCountryObj) {
                // this.standardSelectionDisabled = false;
                if (this.asStandardCountries.includes(this.selectedCountryObj.iso)) {
                    this.calcStandardId = 100; // AS Standard
                    // this.drpCableSizing = 0;
                }
                else if (this.bsStandardCountries.includes(this.selectedCountryObj.iso)) {
                    this.calcStandardId = 102; // BS Standard
                    // this.drpCableSizing = 2;
                }
                else if (this.necStandardCountries.includes(this.selectedCountryObj.iso)) {
                    this.calcStandardId = 104; // NEC Standard
                    // this.drpCableSizing = 4;
                }
                else {
                    this.calcStandardId = 103; // IEC Standard
                    // this.drpCableSizing = 3;
                }
            }
            this.getCurrentCurrencyRate();
        });
    }

    sortCountries(): void {
        this.Countries = [...this.Countries.sort((a, b) => this._commonLookupServiceProxy.compareCountries(a, b, this.selectedCountryObj.countryName))];
        if (this.selectedCountryObj.countryName != "Australia") {
            this.replaceTextInSubheading();
        }
    }

    getCurrentCurrencyRate() {
        let currency: string = "AUD";
        currency = this.calcStandardId == 100 || this.calcStandardId == 101 ? 'AUD' : this.calcStandardId == 102 ? 'GBP' : this.calcStandardId == 103 ? 'EUR' : this.calcStandardId == 104 ? 'USD' : 'AUD';
        this.isUpdating = true;
        this._commonLookupServiceProxy.getCurrencyInfo(currency).subscribe((response) => {
            if (response && response.isSuccess && response.data) {
                this.currencyData = JSON.parse(response.data);
            }
            this.GetPlans(this.calcStandardId, true);
        });

    }

    isUpdating: boolean = false;
    trialEnabled: boolean = false;
    private readonly destroy$ = new Subject<void>();
    ngOnInit(): void {
        // this.route.queryParams.subscribe(params => {
        //     if (!this.trialEnabled)
        //         this.trialEnabled = params['trial'] === 'true';
        // });
        this.route.queryParams
            .pipe(takeUntil(this.destroy$))
            .subscribe(params => {
                if (!this.trialEnabled)
                    this.trialEnabled = params['trial'] === 'true';
            });
        $(".showhide").hide();
        this.ishidebutton = 1;
        $(".subscription-button").attr("style", "display: none !important");
    }
    ngAfterViewInit() {
        stripe = Stripe(this.stripeKeySubscribePlans);
        this.ishidebutton = 1;
    }

    loadScripts() {
        const dynamicScripts = [
            'assets/anonymouspage/js/jquery-ui.min.js',
            'assets/anonymouspage/js/jquery.accordion.js',
            'assets/anonymouspage/js/custom.js'];
        for (let i = 0; i < dynamicScripts.length; i++) {
            const node = document.createElement('script');
            node.src = dynamicScripts[i];
            node.type = 'text/javascript';
            node.async = false;
            node.charset = 'utf-8';
            document.getElementsByTagName('body')[0].appendChild(node);
        }

        const dynamicCss = [
            'https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600%7COpen+Sans:400%7CVarela+Round',
            'assets/anonymouspage/css/jquery.accordion.css',
            'assets/anonymouspage/css/styleinside.css'
        ];
        for (let i = 0; i < dynamicCss.length; i++) {
            const node = document.createElement('link');
            node.href = dynamicCss[i];
            node.rel = 'stylesheet';
            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        $('link[href="assets/anonymouspage/css/styleinside.css"]').remove();
        $(".subscription-button").attr("style", "display: block");
    }

    GetPlans(standardid: number, isFirstTime: boolean = false): void {
        this._planService.getPlans(standardid).subscribe(result => {
            this.isUpdating = false;
            if (result.items.length > 0) {
                this.planOutput = result.items;
                this.annualPlanOutput = this.planOutput.filter(x => x.planType == 1).sort((a, b) => a.planLevel - b.planLevel);
                this.monthlyPlanOutput = this.planOutput.filter(x => x.planType == 2).sort((a, b) => a.planLevel - b.planLevel);
                this.annualPlanOutput.forEach(p => {
                    p.featureText1 = p.featureText1 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText1) : '';
                    p.featureText2 = p.featureText2 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText2) : '';
                    p.featureText3 = p.featureText3 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText3) : '';
                    p.featureText4 = p.featureText4 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText4) : '';
                    p.featureText5 = p.featureText5 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText5) : '';
                    p.featureText6 = p.featureText6 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText6) : '';
                    p.featureText7 = p.featureText7 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText7) : '';
                    p.featureText8 = p.featureText8 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText8) : '';
                    p.featureText9 = p.featureText9 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText9) : '';
                    p.featureText10 = p.featureText10 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText10) : '';
                    p.featureText11 = p.featureText11 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText11) : '';
                });
                this.monthlyPlanOutput.forEach(p => {
                    p.featureText1 = p.featureText1 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText1) : '';
                    p.featureText2 = p.featureText2 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText2) : '';
                    p.featureText3 = p.featureText3 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText3) : '';
                    p.featureText4 = p.featureText4 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText4) : '';
                    p.featureText5 = p.featureText5 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText5) : '';
                    p.featureText6 = p.featureText6 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText6) : '';
                    p.featureText7 = p.featureText7 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText7) : '';
                    p.featureText8 = p.featureText8 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText8) : '';
                    p.featureText9 = p.featureText9 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText9) : '';
                    p.featureText10 = p.featureText10 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText10) : '';
                    p.featureText11 = p.featureText11 ? this.html_sanitizer.bypassSecurityTrustHtml(p.featureText11) : '';
                });
            }
            else {
                this.planOutput = [];
                this.annualPlanOutput = [];
                this.monthlyPlanOutput = [];
            }
            if (this.selectedCountryObj != null && this.selectedCountryObj.countryName != "Australia") {
                this.replaceTextInSubheading();
            }
            // if (isFirstTime) {
            //     if (window.innerWidth <= 767 && this.scrollContainer) {
            //         setTimeout(() => {
            //             const el = this.scrollContainer.nativeElement;
            //             el.scrollTo({ left: 50, behavior: 'smooth' });
            //             setTimeout(() => {
            //                 el.scrollTo({ left: 0, behavior: 'smooth' });
            //             }, 600);
            //         }, 500);
            //     }
            // }
            this.updatePrices();
        });
        this._planService.getComparePlans().subscribe(result => {
            if (result.items.length > 0) {
                this.comparePlans = result.items;
                this.groupedComparePlans = this.groupByCalculationType(this.comparePlans);
            }
            else {
                this.comparePlans = [];
                this.groupedComparePlans = [];
            }
        });
    }

    private groupByCalculationType(data: any[]) {
        const grouped: { [key: string]: any[] } = {};

        data.forEach(item => {
            const key = item.calculationTypeId === null ? 'null' : String(item.calculationTypeId);
            if (!grouped[key]) {
                grouped[key] = [];
            }
            grouped[key].push(item);
        });

        return Object.keys(grouped)
            .map(key => ({
                calculationTypeId: key === 'null' ? null : Number(key),
                features: grouped[key]
            }))
            .sort((a, b) => {
                // Handle null case first
                if (a.calculationTypeId === null && b.calculationTypeId !== null) return -1;
                if (a.calculationTypeId !== null && b.calculationTypeId === null) return 1;

                // Custom order: put 8 before 7
                if (a.calculationTypeId === 8 && b.calculationTypeId === 7) return -1;
                if (a.calculationTypeId === 7 && b.calculationTypeId === 8) return 1;

                // Default ascending order
                return (a.calculationTypeId ?? 0) - (b.calculationTypeId ?? 0);
            });
    }

    // Pricing card CTAs depend on the user's subscription state, not URL query params.
    // Free users see Trial + Buy on paid tiers; trialing users see Skip Trial on their
    // tier and Buy on others; paid subscribers see Current Plan + Buy on other tiers.
    isFreePlan(plan: PlanOutput): boolean {
        return plan.heading?.toLowerCase() === 'free';
    }

    isPaidPlan(plan: PlanOutput): boolean {
        return !this.isFreePlan(plan);
    }

    isWebfacingGuest(): boolean {
        return this.isFromWebfacing && (!this.user || this.user.isWebFacingUser);
    }

    isUsersCurrentPlan(plan: PlanOutput): boolean {
        if (this.isFromHomePgae || !this.user || this.user.totalLicenseCount !== this.noOfUsers) {
            return false;
        }
        if (!this.premiumUser && !this.isFreePlan(plan)) {
            return false;
        }

        const matchesStripeOrLevel =
            plan.stripePlanId === this.user.userStripePlanId ||
            (plan.planLevel === this.user.userStripePlanLevel && plan.interval === 'year');

        const matchesFree =
            (!this.user.userStripePlanId || this.user.userStripePlanId === '-1') &&
            this.isFreePlan(plan) &&
            this.user.userStripePlanInterval === 'year';

        return (matchesStripeOrLevel || matchesFree) && (this.premiumUser || this.isFreePlan(plan));
    }

    isPlanCtaHidden(plan: PlanOutput): boolean {
        return (this.premiumUser && !!this.user?.userStripePlanId && this.user.userStripePlanId !== '-1' && this.isFreePlan(plan))
            || (this.isFreePlan(plan) && (!this.user?.userStripePlanId || this.user.userStripePlanId === '-1') && this.noOfUsers > 1)
            || (this.isFreePlan(plan) && !!this.user?.userStripePlanId && !this.premiumUser);
    }

    isPlanCtaContainerHidden(plan: PlanOutput): boolean {
        return this.isFreePlan(plan) && (!this.user || this.user.isWebFacingUser);
    }

    isCurrentPlanButtonDisabled(plan: PlanOutput): boolean {
        if (this.btnDisabled) {
            return true;
        }
        if (this.user?.isTrialing) {
            return false;
        }
        return this.isUsersCurrentPlan(plan) && !this.isFromHomePgae;
    }

    showPlanStatusButton(plan: PlanOutput): boolean {
        return this.isUsersCurrentPlan(plan) && !this.isPlanCtaHidden(plan) && !this.isPlanCtaContainerHidden(plan);
    }

    getPlanStatusLabel(plan: PlanOutput, compact = false): string {
        if (this.user?.isTrialing) {
            return 'Skip Trial';
        }
        return compact ? 'Current' : 'Current Plan';
    }

    showTrialButton(plan: PlanOutput): boolean {
        if (this.isFromHomePgae || !this.isPaidPlan(plan) || this.isUsersCurrentPlan(plan) || this.isPlanCtaHidden(plan) || this.isPlanCtaContainerHidden(plan)) {
            return false;
        }
        if (this.isWebfacingGuest() || this.user?.isTrialing) {
            return false;
        }
        return this._appSessionService.isEligibleForTrial();
    }

    showBuyButton(plan: PlanOutput): boolean {
        if (this.isFromHomePgae || !this.isPaidPlan(plan) || this.isUsersCurrentPlan(plan) || this.isPlanCtaHidden(plan) || this.isPlanCtaContainerHidden(plan)) {
            return false;
        }
        return !this.isWebfacingGuest();
    }

    showGuestPaidPlanButton(plan: PlanOutput): boolean {
        return this.isPaidPlan(plan) && this.isWebfacingGuest() && !this.isPlanCtaHidden(plan) && !this.isPlanCtaContainerHidden(plan);
    }

    showCreateAccountButton(plan: PlanOutput): boolean {
        return this.isFreePlan(plan) && (!this.user || this.user.isWebFacingUser);
    }

    getBuyButtonLabel(compact = false): string {
        return compact ? 'Select' : 'Buy Now';
    }

    // startTrial is set by the clicked button; replaces URL-driven trial mode.
    BuySubscription(plan: PlanOutput, startTrial = false): void {
        if (this.isFromHomePgae) {
            this._router.navigate(['/create-free-account']);
        }
        else if (this.user?.isTrialing && this.user?.userStripePlanId == plan.stripePlanId && !startTrial) {
            this.SkipTrial();
        }
        else if (this.user?.companyId > 0 && !this.user.isBillingManager) {
            this._modalPopupService.confirm("Billing Manager Privileges Required", "You are currently under a company account.<br>Please ask them to upgrade.<br><br>Alternatively, you can purchase your own license, but this will disconnect you from the team account.", (value) => {
                if (value) {
                    setTimeout(() => {
                        this._modalPopupService.confirm("Leave the Company Account", "This action will remove you from the company account. Are you sure you want to proceed?", (value) => {
                            if (value) {
                                let obj = { companyId: this.user?.companyId, userId: this.user?.id };
                                this._companyAccountService.RemoveFromTeamBySelf(obj).pipe(finalize(() => { })).subscribe((result: any) => {
                                    if (result) {
                                        window.location.reload();
                                    }
                                });
                            }
                        }, "fa-warning text-warning", "Proceed", undefined, "Cancel");
                    }, 500);
                }
            }, "", "Leave Account", "btn-danger", "Cancel");
        }
        else if (this.user && !this.user?.isWebFacingUser && this.user?.isPlanAddedManually) {
            this._modalPopupService.error("Manage Subscription", "Your subscription has been paid via direct invoice. Please contact <a href='mailto:sales@elek.com'>sales@elek.com</a> to make changes.", "Close");
        }
        else if (this.isFromWebfacing && (!this.user || this.user?.isWebFacingUser)) {
            this.CreateAccount(plan);
        }
        else if (this.premiumUser && !this.user.isWebFacingUser && !this.isFromHomePgae && this.user.userStripePlanId && (this.noOfUsers != this.user.totalLicenseCount || this.user.userStripePlanId != plan.stripePlanId) && plan.stripePlanId) {
            this.ManageSubscription(this.user, this.loaderService, this._subscriptionService, "subscription_update_confirm", this.noOfUsers, plan.stripePlanId, this.isFromWebfacing);
        }
        else if (this.user && !this.user.isWebFacingUser && !this.isFromHomePgae && plan.stripePlanId && plan.heading.toLowerCase() != 'free') {
            this.btnDisabled = true;
            this._planService.createPlan(plan.id, this.calcStandardId, this.noOfUsers, this.isFromWebfacing, startTrial).subscribe(result => {
                this.errorFlag = (result.split('|')[0] === 'E');

                this.successFlag = (result.split('|')[0] === 'S');

                if (this.errorFlag)
                    this.subscribePlanResult = result.split('|')[1];

                setTimeout(() => {
                    const element = this.successFlag ? document.getElementById('successDiv') : document.getElementById('errorDiv');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }
                });
                if (this.successFlag) {
                    this.subscribePlanResult = 'Redirecting to checkout page...';

                    setTimeout(() => {
                        stripe.redirectToCheckout({
                            sessionId: result.split('|')[1],
                        })
                            .then((result) => {

                            });
                    });
                }
            }, () => { }, () => {
                this.btnDisabled = false;
            });
        }
        else if ((this.user && this.user.isWebFacingUser && this.isFromWebfacing) || this.isFromHomePgae) {
            this._modalPopupService.confirm("Login-Required", "Please log in to buy your package.", (value) => {
                if (value) {
                    this.ngbModalService.open(WebfacingLoginComponent, {
                        centered: true,
                        backdrop: 'static',
                        keyboard: false,
                        animation: true
                    });
                }
            }, "fa-times-circle text-danger", "Log In", "btn-primary", "Close");
        }
    }

    CreateAccount(plan: PlanOutput) {
        if (this.isFromWebfacing) {
            const modalRef = this.ngbModalService.open(WebfacingRegisterComponent, {
                centered: true,
                backdrop: 'static',
                keyboard: false,
                animation: true
            });

            // ✅ Subscribe to modal close event
            modalRef.closed.subscribe((result) => {
                this.appSession.init().then((result) => {
                    this.user = this._appSessionService.user;
                    this.premiumUser = this.user?.premiumUser;
                    if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
                        && this.user?.periodEndDate == "Inactive") {
                        this.premiumUser = false;
                    }
                    else {
                        if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
                            && this.user?.periodEndDate != "succeeded") {
                            this.premiumUser = false;
                        }
                    }
                    this.planLevel = this.user?.userStripePlanLevel;
                    this.isPlanAddedManually = this.user?.isPlanAddedManually;
                    if (this.user?.userStripePlanInterval == 'month') {
                        this.isMonthly = true;
                    }
                    this.hasPlanExpired = this.premiumUser && MomentHelper.IsSubscriptionDateExpired(this.user?.expirationDate);
                    if (plan.heading.toLowerCase() == 'free') {
                        location.reload();
                    }
                    else {
                        this.BuySubscription(plan);
                    }
                });

            });
        }
        else {
            this._router.navigate(['/create-free-account']);
        }
    }
    
    onddlCountryChange(data) {
        this.selectedCountryObj = this.Countries.find(m => m.iso == data.iso);
        if (data.countryName != "Australia") {
            this.replaceTextInSubheading();
        }
        else {
            this.GetPlans(this.calcStandardId);
        }
    }
    replaceTextInSubheading() {
        for (var i = 0; i < this.monthlyPlanOutput.length; i++) {
            this.monthlyPlanOutput[i].subHeading = this.monthlyPlanOutput[i].subHeading.replace(',GST Inc', '')
        }
        for (var i = 0; i < this.annualPlanOutput.length; i++) {
            this.annualPlanOutput[i].subHeading = this.annualPlanOutput[i].subHeading.replace(',GST Inc', '')
        }
    }
    getCurrencyForPrice(amount) {
        let price = amount;

        if (this.currencyData && this.currencyData.data && this.selectedCountryObj) {
            try {
                let rate = this.currencyData.data[this.selectedCountryObj.currency];
                if (rate) {
                    let converted = parseFloat(amount) * parseFloat(rate.value);
                    return converted.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                }
            }
            catch {
                return parseFloat(price).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            }
        }

        return parseFloat(price).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    updatePrices() {
        const users = Math.max(1, this.noOfUsers || 1);
        this.noOfUsers = users; // Ensure noOfUsers is always a positive integer
        for (const plan of this.annualPlanOutput as any[]) {
            if (plan.amount === 0) {
                plan.calculatedPrice = 0;
            } else {
                const additionalUsers = users - 1;
                const extraCost = additionalUsers * (plan.amount * 0.5);
                plan.calculatedPrice = plan.amount + extraCost;
            }
        }

        for (const plan of this.monthlyPlanOutput as any[]) {
            if (plan.amount === 0) {
                plan.calculatedPrice = 0;
            } else {
                const additionalUsers = users - 1;
                const extraCost = additionalUsers * (plan.amount * 0.5);
                plan.calculatedPrice = plan.amount + extraCost;
            }
        }
    }

    CommonValidationFn(event: any) {
        if (parseFloat(event.target.value) > parseFloat(event.target.max)) {
            event.target.value = event.target.max;
            this.noOfUsers = event.target.value;
        }
        if (parseFloat(event.target.value) < parseFloat(event.target.min) || event.target.value === '') {
            event.target.value = event.target.min;
            this.noOfUsers = event.target.value;
        }
        // if (this.noOfUsers > 1 && this.trialEnabled) {
        //     this.trialEnabled = false;
        // }
        // else if (this.noOfUsers == 1 && !this.trialEnabled) {
        //     const trialValue = this.route.snapshot.queryParamMap.get('trial');

        //     if (trialValue !== null) {
        //         if (trialValue === 'true') {
        //             this.trialEnabled = true;
        //         }
        //     }
        // }
        this.updatePrices();
    }

    isNumericValue(value: any): boolean {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    getCalculationTypeName(calculationTypeId: number): string {
        switch (calculationTypeId) {
            case 1:
                return 'CABLE SIZING';
            case 4:
                return 'MAXIMUM DEMAND';
            case 5:
                return 'PROTECTION COORDINATION';
            case 6:
                return 'CABLE PULLING';
            case 7:
                return 'NETWORK DESIGN';
            case 8:
                return 'ARC FLASH';
            default:
                return '';
        }
    }

    sections = [
        // {
        //     title: 'PRICES',
        //     expanded: true,
        //     content: [
        //         {
        //             heading: 'Price (Australian standard)',
        //             data: [
        //                 ['$99 per year<br>$15 per month<br>50% discount for additional users (teams)'],
        //                 ['$290 per year<br>$45 per month<br>50% discount for additional users (teams)'],
        //                 ['$650 per year<br>$99 per month<br>50% discount for additional users (teams)']
        //             ]
        //         },
        //         {
        //             heading: 'Price (British standard)',
        //             data: [
        //                 ['£57 per year<br>£10 per month<br>50% discount for additional users (teams)'],
        //                 ['£369 per year<br>£49 per month<br>50% discount for additional users (teams)'],
        //                 ['£650 per year<br>£99 per month<br>50% discount for additional users (teams)']
        //             ]
        //         },
        //         {
        //             heading: 'Price (IEC standard)',
        //             data: [
        //                 ['€68 per year<br>€12 per month<br>50% discount for additional users (teams)'],
        //                 ['€199 per year<br>€35 per month<br>50% discount for additional users (teams)'],
        //                 ['€435 per year<br>€57 per month<br>50% discount for additional users (teams)']
        //             ]
        //         }
        //     ]
        // },
        {
            title: 'GENERAL FEATURES',
            expanded: true,
            features: true,
            content: [
                {
                    heading: 'Stored calculations (total)',
                    data: [
                        ['150 assorted'],
                        ['500 assorted'],
                        ['10000 assorted']
                    ]
                },
                {
                    heading: 'Reports generated per day',
                    data: [
                        ['50 assorted'],
                        ['250 assorted'],
                        ['3000 assorted']
                    ]
                }
            ]
        }
    ];

    toggleSection(index: number): void {
        this.expanded = []
        this.sections.forEach((section, i) => {
            section.expanded = i === index ? !section.expanded : false;
        });
    }

    expanded: boolean[] = [];
    toggleSectionIndex(index: number): void {
        this.sections.forEach((section) => {
            section.expanded = false;
        });

        const len = this.groupedComparePlans?.length ?? 0;
        if (this.expanded.length !== len) this.expanded = new Array(len).fill(false);

        const isOpening = !this.expanded[index];
        this.expanded.fill(false);
        this.expanded[index] = isOpening;
    }

    increase() {
        if (this.noOfUsers < 1000) { this.noOfUsers++; this.updatePrices(); }
    }

    decrease() {
        if (this.noOfUsers > 1) { this.noOfUsers--; this.updatePrices(); }
    }

    SkipTrial() {
        this.onSkipTrial(this.loaderService, this._planService, this._commonLookupServiceProxy);
    }

    isBetweenWidth = false;
    isSelectMobile = false;

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.checkWidth(event.target.innerWidth);
    }

    private checkWidth(width: number) {
        this.isBetweenWidth = width >= 1025 && width <= 1405;
        this.isSelectMobile = width < 410;
    }
}
